export function LandingRoute() {
  return (
    <main class="flex min-h-screen flex-col items-center justify-center gap-6 p-6">
      <div class="flex items-center gap-3">
        <img src="/logo/mark.svg" alt="" class="h-10 w-10" />
        <h1 class="display-italic text-4xl leading-none">Backstop</h1>
      </div>
      <p class="text-center text-sm text-surface-fg/70">
        End-to-end encrypted parental controls for your family.
      </p>
      <div class="flex gap-3">
        <a
          href="/signup"
          class="inline-flex h-10 items-center rounded bg-brand-500 px-4 text-base font-medium text-white hover:bg-brand-600"
        >
          Create account
        </a>
        <a
          href="/login"
          class="inline-flex h-10 items-center rounded border border-surface-muted/40 px-4 text-base font-medium text-surface-fg hover:bg-surface-muted/10"
        >
          Log in
        </a>
      </div>
    </main>
  );
}
